<script>
  import {getContext} from 'svelte';
  import {contractMarkets$, sortParams$, pilotContractMarkets$} from '@/modules/markets/streams-market';
  import Search from '@/widgets/Search.svelte';
  import {marketUtil} from '@/modules/markets/util2';
  import {goto} from '@sapper/app';
  import {coinUtil} from '@/helper';
  import {FETURES_CATEGORY} from '@/modules/header/const';
  import {PerpetualType} from '@/modules/markets/enum';
  import lang from '../../Header.lang';

  const LG = getContext('LG');

  let searchKey = '';
  let contractType = PerpetualType.USDS;
  let advancedFilter = {
    volume: {
      min: 0,
      max: Infinity,
    },
    change: {
      min: -Infinity,
      max: Infinity,
    },
  };

  export let name;
  export let categoryId;
  export let innerHeight = 531

  $: markets =
    name === FETURES_CATEGORY.PILOT
      ? marketUtil.genContractMarketsForPilot($pilotContractMarkets$ || [], $sortParams$, advancedFilter, categoryId, contractType, searchKey)
      : marketUtil.genContractMarkets($contractMarkets$, $sortParams$, categoryId, searchKey);

  function getSearchKey(e) {
    searchKey = e.detail || '';
  }

  function handleToTrade(info) {
    if (info.tradeLink) {
      goto(info.tradeLink);
    }
  }
</script>

<style lang="scss">
  .wrap {
    box-sizing: border-box;
    padding: 16px 8px;
    width: 344px;
    height: 531px;
    background: rgba(21, 21, 21, 0.85);
    cursor: default;
    border-bottom-right-radius: 12px;
  }
  .search-box {
    padding: 0 12px;
  }
  .wrap :global(.search input) {
    color: #fff;
    caret-color: #fff;
  }
  .market {
    overflow-y: auto;
    .c-gray {
      color: #888b94;
    }
    li {
      padding: 8px 12px;
      &:hover {
        background: rgba(255,255,255, 0.06);
      }
    }
    .gap-4 {
      gap: 4px;
    }
  }
</style>

<div class="wrap df fdc" style="height: {innerHeight}px">
  <div class="search-box">
    <Search on:change={getSearchKey} placeholder={LG(lang.Search)} />
  </div>
  <div class="f1 mt8 sv market">
    {#if !!markets.length}
      <ul>
        {#each markets as market}
          <li class="df aic jcsb TW cp br8" on:click={handleToTrade.bind(null, market)}>
            <div class="df aic">
              <img src={coinUtil.getUrl(market.baseCurrency)} alt={market.baseCurrency} width="28" height="28" />
              <span class="ml12">{market.pairName}</span>
            </div>
            <div class="df fdc aife gap-4">
              <span>{market.close}</span>
              <span class:up={market.changePercent > 0} class:down={market.changePercent < 0}>{market.changePercentStr}</span>
            </div>
          </li>
        {/each}
      </ul>
    {:else}
      <div class="f16 fw3 TW wp100 df aic jcc c-gray" style="height: 200px">{LG(lang.NoData)}</div>
    {/if}
  </div>
</div>
